<template>
    <div class="overflow-y-auto flex flex-col flex-1">
        <div
            class="overflow-y-auto">
            <panel-header
                :title="title"
                :align="isFullHeight ? 'left' : 'center'"
            />

            <slot />
        </div>

        <slot name="actions" />
    </div>
</template>

<script>
    import PanelHeader from './PanelHeader.vue';

    export default {
        components: {
            PanelHeader,
        },
        props: {
            title: {
                type: String,
                default: 'Back', // TODO: find out how to access this.$t('MENU_BACK') in props
            },
            isFullHeight: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
